export const isGridView = (token, list) =>{
    return token?.dataView?.[list] === "grid_view";
};